import { bindable, customElement, inject, LogManager } from 'aurelia-framework';
import { ChoiceLoader } from '../loader/choice-loader.js';
import { I18N } from 'aurelia-i18n';
import * as _ from 'lodash';

import './checkboxes-choice-element.less';

const logger = LogManager.getLogger('CheckboxesChoiceElement');

@customElement('sio-feature-card-choice-input')
@inject(ChoiceLoader, I18N)
export class FeatureCardChoiceElement {
    @bindable config;
    @bindable({ defaultBindingMode: 2 }) value;

    required = [];

    constructor(choiceLoader, i18n) {
        this.choiceLoader = choiceLoader;
        this.i18n = i18n;
    }

    async configChanged(newValue, oldValue) {
        this.loading = true;

        if (this.config.translateChoiceLabel == null) {
            this.config.translateChoiceLabel = true;
        }

        const value = [];

        let conditions = this.config.conditions ?? {};

        this.choices = await this.choiceLoader
            .getChoices(this.config, conditions)
            .then((choices) => {
                let result = [];

                choices.forEach((element) => {
                    result.push({
                        label: this.config.translateChoiceLabel
                            ? this.i18n.tr(element.label)
                            : element.label,
                        value: element.value,
                        group: this.config.translateChoiceLabel
                            ? this.i18n.tr(element.group)
                            : element.group,
                        help: element.help ?? null,
                        required: element.required ?? false,
                    });

                    // avoid unchecked items if value is array of objects
                    if (this.value && element.value.id) {
                        _.forEach(this.value, (v) => {
                            if (v.id && v.id === element.value.id) {
                                value.push(element.value);
                            }
                        });
                    }
                });

                this.loading = false;

                result = _.groupBy(result, 'group');

                _.forEach(result, (items) => {
                    items.sort((a, b) =>
                        String(a.label).localeCompare(String(b.label))
                    );
                });

                const ordered = {};
                Object.keys(result)
                    .sort((a, b) => {
                        if (a === 'Sonstige') return 1;
                        if (b === 'Sonstige') return -1;
                        return a.localeCompare(b);
                    })
                    .forEach((key) => {
                        ordered[key] = result[key];
                    });

                return ordered;
            });

        this.value = value.length
            ? value
            : !this.value
            ? []
            : _.castArray(this.value);
        this.addRequired();
    }

    addRequired() {
        this.required = [];

        _.forEach(this.choices, (choicesGroup) => {
            _.forEach(choicesGroup, (choice) => {
                const val = choice.value;

                if (choice.required) {
                    this.required.push(choice.value);
                }

                if (choice.required && !this.value.includes(val)) {
                    this.value.push(choice.value);
                }
            });
        });
    }

    onChange() {
        this.addRequired();
        //Somewhat of a hack to trigger value change event and not reimplement the wheel here
        this.value = _.clone(this.value);
    }
}
